import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@/api/ajax';

export interface PartReq {
  /**
   * 备件编码
   */
  partNo?: string;
}

export interface PartSubstituteResp {
  /**
   * 备件名称
   */
  partName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 替换关系
   */
  substituteList?: SubstituteItem[];
}
export interface SubstituteItem {
  /**
   * 是否替换组：1-是，0-否
   */
  group?: number;
  /**
   * 新件列表
   */
  newList?: PartInfo[];
  /**
   * 替换备注
   */
  note?: string;
  /**
   * 旧件列表
   */
  oldList?: PartInfo1[];
  /**
   * 替换关系：SUBSTITUTE_EPC_RELATION NN新旧件不互换|NY新件替换旧件|YN旧件替换新件|YY新旧件可互换
   */
  substituteTypeCode?: string;
  /**
   * 替换关系名称
   */
  substituteTypeName?: string;
}
export interface PartInfo {
  /**
   * 备件名称
   */
  partName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 价格展示：0-隐藏，1-展示
   */
  priceDisplay?: number;
  /**
   * 备件销售价格
   */
  salePrice?: number;
  /**
   * 销售状态：0-停售 1-正常
   */
  saleState?: number;
}
export interface PartInfo1 {
  /**
   * 备件名称
   */
  partName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 价格展示：0-隐藏，1-展示
   */
  priceDisplay?: number;
  /**
   * 备件销售价格
   */
  salePrice?: number;
  /**
   * 销售状态：0-停售 1-正常
   */
  saleState?: number;
}

/**
 * @operationId partSubstituteUsingPOST
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/partSubstituteUsingPOST
 */
export function partSubstituteUsingPost(
  data: PartReq
): XDragonApiResponsePromise<PartSubstituteResp> {
  return ajax({
    url: '/api/tis/web/epc/catalog/part/substitute',
    method: 'post',
    data: data
  });
}
